// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Fqqu","footer":"Form_footer__7tpHr"};